import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { PlModalService } from '../../services';

// TODO: For now will display dropzone and only single file
@Component({
  selector: 'pl-input-file',
  templateUrl: './pl-input-file.component.html',
  styleUrls: ['./pl-input-file.component.scss'],
})
export class PlInputFileComponent {
  @ViewChild('xQAEleRef') xQAEleRef: ElementRef;

  @ViewChild('fileInputEleRef') fileInputEleRef: ElementRef;

  @Input() loading: boolean;

  @Input() accept: string;

  @Input() maxFileSize: number;

  @Output() valueChange: EventEmitter<any> = new EventEmitter();

  fileList: any[];

  constructor(private modal: PlModalService) {}

  private proccessFiles(files: FileList) {
    if (this.loading) {
      return;
    }
    const file = files[0];
    if (file) {
      if (this.accept && !this.accept.includes(file.type)) {
        // In future lets do this modal more custom
        this.modal.openDialog({
          title: 'We’re having trouble with that file',
          image: '/assets/img/bulk-upload/questions.png',
          message:
            'This is an unsupported file type,<br/> please download and use the template or upload a csv or xlsx file',
          buttons: [{ text: 'OK' }],
        });
        return;
      }
      if (this.maxFileSize) {
        const maxFileSize = this.maxFileSize * 1024 * 1024;
        if (file.size >= maxFileSize) {
          this.modal.openDialog({
            title: 'Your file is too large',
            image: '/assets/img/bulk-upload/warning.png',
            message: `This file exceeds ${this.maxFileSize} MB, please split your caseload into two files and upload them separately or contact ${this.modal.supportEmail} for assistance.`,
            buttons: [{ text: 'OK' }],
          });
          return;
        }
      }
    }

    this.fileList = [file.name];
    this.valueChange.emit(file);
  }

  // Prevents to open the file in new tab
  preventDragOver(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  fileDropped(evt: any) {
    const { files } = evt.dataTransfer;
    evt.preventDefault();
    this.proccessFiles(files);
  }

  filesSelected(evt: any) {
    const { files } = evt.target;
    this.proccessFiles(files);
  }

  openFileExplorer() {
    if (this.loading) {
      return;
    }
    this.fileInputEleRef.nativeElement.click();
  }

  clearFiles() {
    this.fileInputEleRef.nativeElement.value = '';
    this.fileList = [];
    this.valueChange.emit(null);
  }
}
